@if (!!form) {
  <div [formGroup]="form">
    @for (category of categories; track category) {
      <div class="row margin-10">
        <div class="flex">
          <div class="flex" (click)="toggleOption(category)">
            <input
              class="checkbox"
              type="checkbox"
              [id]="category.id"
              [formControlName]="category.id"
              (change)="toggleOption(category)"
            />
            <label class="checkbox-label" [attr.aria-label]="category.name"></label>
            @if (category.caption) {
              <p class="pad-left-10">
                <span>{{ category.name }}</span
                ><br /><span class="caption">{{ category.caption }}</span>
              </p>
            }
          </div>
          @if (!category.caption) {
            <a (click)="openModal(category)">{{ category.name }}</a>
          }
          @if (!category.caption) {
            <span (click)="openModal(category)" class="icon-help block help-color"></span>
          }
        </div>
      </div>
    }
  </div>
}
<ds-modal [id]="helpModal" [closeOthers]="true" [maxWidth]="800">
  <h1>
    {{ header }}
  </h1>
  <pre>{{ body }}</pre>
</ds-modal>
